import Vue from 'vue'

const Abem = {}

let block = null

Abem.install = function () {
  /**
  * Atomic BEM function helper to generate element classes.
  */
  Vue.prototype.$abem = function abem (args) {
    if (args.block) {
      block = args.block
    }

    if (!block) {
      throw new Error('abem block scope cannot be determined. At least one top level element must define the block scope.')
    }

    const element = args.element ? `__${args.element}` : ''

    args.modifiers = args.modifiers || []
    args.additional = args.additional || []

    // Mapper for processing modifier classes with hyphen prefixes.
    const modifierMapper = m => {
      if (typeof m === 'object') {
        const modifier = Object.keys(m)[0]
        const shouldApply = !!m[modifier]
        return shouldApply ? `-${modifier}` : ''
      }
      return `-${m}`
    }

    // Mapper for processing additional non-abem classes.
    const additionalMapper = a => {
      if (typeof a === 'object') {
        const additional = Object.keys(a)[0]
        const shouldApply = !!a[additional]
        return shouldApply ? `${additional}` : ''
      }
      return `${a}`
    }

    return [
      block + element,
      args.modifiers.map(modifierMapper).filter(x => !!x).join(' '),
      args.additional.map(additionalMapper).filter(x => !!x).join(' ')
    ].filter(x => x).join(' ')
  }
}

Vue.use(Abem)
